export const WRITE_FILE = 'WRITE_FILE';
export const HARD_RESET = 'HARD_RESET';
export const SET_FILES = 'SET_FILES';
export const ADD_FOLDER = 'ADD_FOLDER';
export const DEL_FILE = 'DEL_FILE';
export const RENAME_FILE = 'RENAME_FILE';